import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import mapImage from "@/assets/map-white.png";

const MapSection = () => {
  const { t } = useTranslation('home');

  const stats = [
    { value: "200+", label: t('map.vessels') },
    { value: "45+", label: t('map.customers') },
    { value: "15+", label: t('map.countries') },
  ];

  return (
    <section className="relative py-24 md:py-32 overflow-hidden bg-surface-light">
      <div className="absolute inset-0 flex items-center justify-center scale-125">
        <img src={mapImage} alt="Vessel monitoring system global coverage map" className="w-full h-full object-cover opacity-60" loading="lazy" />
      </div>
      <div className="container relative z-10 mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }} className="text-center mb-20">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4">{t('map.heading')}</h2>
        </motion.div>
        <div className="grid grid-cols-3 gap-8 max-w-3xl mx-auto">
          {stats.map((stat, i) => (
            <motion.div key={stat.label} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.15 }} className="text-center">
              <div className="font-display text-4xl md:text-5xl font-bold text-primary mb-2">{stat.value}</div>
              <div className="text-base md:text-lg text-muted-foreground font-medium uppercase tracking-wider">{stat.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MapSection;
